module.exports = __webpack_public_path__ + "img/fuison5-main.f6f63457.jpg";